import { DocumentScannerComponent } from './document-scanner/document-scanner.component';
import { TokenStorageService } from './../../shared/service/token-storage.service';
import swal from 'sweetalert2';
import { DocumentTypeService } from './../../service/document-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicantRequestService } from './../../service/applicant-request.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { __param } from 'tslib';



import { NgWizardConfig, THEME, StepChangedArgs, NgWizardService } from 'ng-wizard';
import {NationalityModel} from '../../shared/dto/nationality.model';
import {NationalityService} from '../../shared/service/nationality.service';
import {ReversedReturnRequestDetailsComponent} from '../../reversed-blacklist-process/reversed-process-request-viewer/reversed-return-request-details/reversed-return-request-details.component';
import {ActionMode} from '../../shared/enums/action-mode.enum';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {ApprovalService} from '../../service/approval.service';
import {UploadDocumentComponent} from './upload-document/upload-document.component';
import {MatTableDataSource} from '@angular/material/table';
import {DocumentTypeModel} from '../../shared/dto/document-type.model';
import {StatusModel} from '../../shared/dto/status.model';

@Component({
  selector: 'app-online-application-detail',
  templateUrl: './online-application-detail.component.html',
  styleUrls: ['./online-application-detail.component.scss']
})
export class OnlineApplicationDetailComponent implements OnInit {

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      showNextButton: false,
      showPreviousButton: false
  },
    anchorSettings:{
      anchorClickable: false
    }};

  protected applicantId = null;
  public valid: boolean;
  public isValid: boolean = false;
  public pendingApplicantDetail = [];
  public paymentRefNo: number;
  public showdiv: boolean = false;

  // coc checkboxes
  public isSidAppliedBefore = true;
  isLoading10: boolean = false;
  dataSource: MatTableDataSource<any>;
  public documentTypeModel: DocumentTypeModel[];
  public docType= new DocumentTypeModel();

  public statusModel: StatusModel [];

  displayedColumns: string[] = ['description','action'];

  // debarred checkboxes
  public isdebarredCdc = false;
  public isdebarredSid = false;
  public isdebarredCoc = false;

  //for validate special characters
  showAddresserror=false;
  showspecialCharacerror=false;
  showbirthPlaceerror=false;

  // gender
  public gender = {
    male: false,
    female: false
  };

  //doc Types
  public documentTypes = [];
  public nationality: NationalityModel[];

  public showFinal = false;
  public showBack = false;
  public showNext = false;

  public wizardIndex :number = 0;

  public showLable1 :boolean = false;
  public  showLable2:boolean =  false;

  public userName: string;
  type: string;
  isLoading: boolean = false;
  sex: string;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              public applicantRequestService: ApplicantRequestService,
              public documentType: DocumentTypeService,
              private spinnerService: NgxUiLoaderService,
              private tokenStorageService: TokenStorageService,
              private nationalityService: NationalityService,
              private approvalService: ApprovalService,) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.userName=this.tokenStorageService.getUserObjectToken().username;
    });
  }

  applicantFormEdit = new FormGroup({
    applicantRequestId: new FormControl(''),
    applicantType: new FormControl(''),
    fullName: new FormControl(''),
    familyName: new FormControl(''),
    givenName: new FormControl(''),
    nameWithInitials: new FormControl(''),
    cardDisplayName: new FormControl(''),
    cdcNo: new FormControl(''),
    cdcDateOfIssue: new FormControl(''),
    cdcDateOfExpiry: new FormControl(''),
    cocNo: new FormControl(''),
    gender: new FormControl(''),
    dateOfBirth: new FormControl(''),
    placeOfBirth: new FormControl(''),
    nationality: new FormControl(''),
    passportNo: new FormControl(''),
    referenceNo: new FormControl(''),
    passportDateOfIssue: new FormControl(''),
    passportDateOfExpire: new FormControl(''),
    nic: new FormControl(''),
    nicDateOfIssue: new FormControl(''),
    email: new FormControl(''),
    mobileNo: new FormControl(''),
    height: new FormControl(''),
    distinguishingMarks: new FormControl(''),
    permanentAddress: new FormControl(''),
    sidAppliedBefore: new FormControl(''),
    debarredCdc: new FormControl(''),
    debarredSid: new FormControl(''),
    debarredCoc: new FormControl(''),
    requestDate: new FormControl(''),
    currentStage: new FormControl(''),
    createdTime: new FormControl(''),
    lastUpdatedTime: new FormControl(''),
    lastUpdatedUser: new FormControl(this.tokenStorageService.getUserObjectToken().username),
    sid:new FormControl(),
    sidIssueDate: new FormControl(),
    sidExpDate: new FormControl(),
    sidLostReason: new FormControl(),
    remark: new FormControl(),
  });

  ngOnInit() {
    this.onGetIdFromUrl();
    this.onLoadApplicantDetails();
    this.getNationality();
    this.getDocumentType();
    this.getRejectStatus();
  }

  openModelPreview() {
    this.showdiv = true;
  }

  closeModel (){
    this.showdiv = false;
  }

  private getNationality(): void {
    this.nationalityService.getAllNationalities().subscribe(
      (data: NationalityModel[]) => {
        this.nationality = data;
      }
    );
  }

  onGetIdFromUrl() {
    this.route.params.subscribe(
      (param: Params) => {
        this.applicantId = param.referanceId;
      }
    );
  }

  finalSave(){
    this.isLoading = true;
    this.onUpdateApplicantDetails();
  }

  dataEntryRejectRequest(){

    let rejectRemark = '';

    swal.fire({
      title: 'Are you sure, you want to reject this request?',
      input: 'select',
      // inputAttributes: {
      //   autocapitalize: 'off'
      // },
      inputOptions: {
        'IND': 'Incorrect Data',
        'USD': 'Unclear Scanned Document',
        'ISD': 'Incorrect Scanned Document',
      },
      showCancelButton: true,
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancel',
      inputPlaceholder: 'Select the Reject Reason',
      preConfirm: (remark) => {
        if (remark == '' || remark == null) {
          swal.showValidationMessage(`Please Enter Reject Remark!`);
          return false;
        } else {
          rejectRemark = remark;
          return true;
        }
      },
      allowOutsideClick: () => !swal.isLoading()
    })

    //   inputValidator: function (value) {
    //     return new Promise(function (resolve, reject) {
    //       if (value !== '') {
    //         rejectRemark = value;
    //         resolve();
    //       } else {
    //         resolve('Please Select The Reject Reason!');
    //       }
    //     });
    //   },
    //   allowOutsideClick: () => !swal.isLoading()
    // })
      .then((result) => {
      if (result.value === true) {
        this.applicantRequestService.dataEntryRejectRequest(this.applicantId, this.type, rejectRemark, this.userName).subscribe(
          (result: any) => {
            if(result === true){
              swal.fire('Success', 'Request Rejected Successfully', 'success');
              this.router.navigate(['/dashboard/dashHome'] );
            }else{
              swal.fire('Error', 'Something Went Wrong!', 'error');
            }
          },
          (error) => {
            swal.fire('Error', 'Something Went Wrong!', 'error');
          }, () => {
            this.isLoading = false;
          });
      }else{
        swal.fire('Warning!', 'Operation Cancelled!', 'warning');
      }
    }, reason => {
    });
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.applicantId).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  getRejectStatus(){
    this.applicantRequestService.getRejectStatusList().subscribe(
      (result:any) => {
        this.statusModel = result;
      }
    )
  }

  viewDoc(documentTypeCode:string) {
    this.isLoading10 = true;
    this.docType.appRefID = this.applicantId;
    this.docType.documentTypeCode = documentTypeCode;
    this.applicantRequestService.cardViewDoc(this.docType).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank",  "width=800,height=400");
        this.isLoading10 = false;
      },
      error => {
        this.isLoading10 = false;
        console.log(error);
      }
    );
  }

  reject() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.REJECT;
    this.approvalModel.type = this.type;
    this.approvalModel.process = ActionMode.REJECT;

    const modalRef = this.modalService.open(ReversedReturnRequestDetailsComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.type
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  get FormControls() {
    return this.applicantFormEdit.controls;
  }

  // Load Applicant Details
  onLoadApplicantDetails() {
    this.applicantRequestService.getApplicantDetails(this.applicantId).subscribe(
      (result: any) => {
        this.applicantFormEdit.patchValue(result);

        if(result.cdcAvailable === "1") {
          this.showLable1 = true;
        }
        if(result.cdcAvailable === "0") {
          this.showLable2 = true;
        }

        this.onCheck(result);
      }
    );
  }

  // update Applicant Details
  onUpdateApplicantDetails() {
    this.applicantFormEdit.value.lastUpdatedUser = this.tokenStorageService.getUserObjectToken().username;
    this.applicantRequestService.editApplicantDetails(this.applicantFormEdit.value).subscribe(
      (result: any) => {

        if ( result !== 0) {
          this.printReceipt(result);
        }

        swal.fire('Success', 'Applicant Details Updated', 'success');
        this.router.navigate(['/dashboard/dashHome'] );
      },error1 => {
        swal.fire('Error', 'Server Error', 'error');
      },() =>{
        this.isLoading = false;
      }
    );
  }


  printReceipt(result) {
    this.applicantRequestService.printApplicantPaymentReceipt(result).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();

      },
      error => {
        console.log(error);
      }
    );
  }

  onCheck(result: any) {
    if ( result.gender === 'Male' ) {
        this.gender.male = true;
    }

    if ( result.gender === 'Female' ) {
        this.gender.female = true;
    }

    this.sex = result.gender;

    if(result.sidAppliedBefore == false){
      this.isSidAppliedBefore = false;
    }else{
      this.isSidAppliedBefore = true;
    }
  }

  stepChanged(args: StepChangedArgs) {
    if (args.step.index === 0) {
      this.wizardIndex = args.step.index;
      this.showBack = false;
      this.showNext = true;
      this.showFinal = false;
    }

    if (args.step.index === 1) {
      this.showBack = true;
      this.showNext = true;
      this.showFinal = false;
    }
    if (args.step.index === 2) {
      this.showBack = true;
      this.showNext = true;
      this.showFinal = false;
    }

    if (args.step.index === 3) {
      this.showBack = true;
      this.showFinal = true;
      this.showNext = false;
      this.config.toolbarSettings.showNextButton = false;
    }
  }

  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    if(this.wizardIndex === 0){

      var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>\?]+/;
      var formatIdentification = /[!@#$%^&*()_+\=\[\]{};':"\\|<>\?]+/;

      if(format.test(this.applicantFormEdit.value.permanentAddress) || /\r|\n/.exec(this.applicantFormEdit.value.permanentAddress)){
        this.isValid = false;
        this.showAddresserror=true;
      }else{
        this.isValid = true;
        this.showAddresserror=false;
      }
      if(this.type !== 'Duplicate') {
        if (format.test(this.applicantFormEdit.value.distinguishingMarks) && format.test(this.applicantFormEdit.value.placeOfBirth)) {
          this.isValid = false;
          this.showspecialCharacerror = true;
          this.showbirthPlaceerror = true;
        } else if (formatIdentification.test(this.applicantFormEdit.value.distinguishingMarks) || format.test(this.applicantFormEdit.value.placeOfBirth)) {

          if (formatIdentification.test(this.applicantFormEdit.value.distinguishingMarks)) {
            this.showspecialCharacerror = true;
            this.isValid = false;
          } else if (format.test(this.applicantFormEdit.value.placeOfBirth)) {
            this.isValid = false;
            this.showbirthPlaceerror = true;
          }

        } else {
          this.isValid = true;
          this.showspecialCharacerror = false;
          this.showbirthPlaceerror = false;
        }
      }
    }else{
      this.isValid = true;
    }
    if(this.valid === true && this.isValid === true) {
      this.ngWizardService.next();
    }else if (this.valid === false) {
      swal.fire('Error', 'Please map uploaded document to a document type', 'error');
    }
  }

  onGoBack(value: boolean) {
    this.valid = value;
  }

  unlockRequest(){
    this.approvalService.unlockRequest(this.applicantId).subscribe(
      (data: any) => {
        if(data){
          swal.fire('Success', 'Request Unlock Success!', 'success');
          this.router.navigate(["/dashboard/approval/New"]);
        } else {
          swal.fire('Error', 'Something Went Wrong!', 'error');
        }
      }
    )
  }
}
